(() => {
  const node = document.getElementById('TitaniumConfig');
  if (!node) return;
  const config = JSON.parse(node.textContent), s = config.strings;
  const modal = document.querySelector('.titanium-cart-modal');
  const surfaces = [...document.querySelectorAll('[data-cart-surface]')];
  let cart, busy = false, returnFocus, previousOverflow;
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:cart?.currency || config.currency}).format(cents / 100);
  const root = config.root.endsWith('/') ? config.root : config.root + '/';
  const el = (tag, cls, text) => { const n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; };
  async function request(url, body) {
    const response = await fetch(url, {method:body ? 'POST':'GET',headers:{Accept:'application/json',...(body ? {'Content-Type':'application/json'}:{})},...(body ? {body:JSON.stringify(body)}:{})});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || s.error);
    return data;
  }
  function setBusy(value) {
    busy = value;
    surfaces.forEach(surface => {
      surface.setAttribute('aria-busy', String(value));
      surface.querySelectorAll('[data-cart-action], [data-cart-checkout]').forEach(control => { control.disabled = value; });
    });
  }
  function error(message = '') { surfaces.forEach(surface => { surface.querySelector('[data-cart-error]').textContent = message; }); }
  function button(text, action, label) {
    const n = el('button','',text); n.type = 'button'; n.dataset.cartAction = action;
    if (label) n.setAttribute('aria-label',label); return n;
  }
  function render(surface) {
    const items = surface.querySelector('[data-cart-items]'); items.replaceChildren();
    surface.querySelector('[data-cart-count]').textContent = String(cart.item_count);
    surface.querySelector('[data-cart-summary]').hidden = !cart.items.length;
    if (!cart.items.length) {
      const empty = el('div','tc-empty'); empty.append(el('span','tc-empty-icon','◯'),el('h3','',s.empty),el('p','',s.emptyHint));
      const shop = el('a','tc-checkout',s.shop); shop.href = config.productUrl; empty.append(shop); items.append(empty);
    }
    for (const item of cart.items) {
      const row = el('article','tc-line'); row.dataset.key = item.key;
      if (item.image) { const img = el('img'); img.src=item.image; img.alt=item.product_title; img.width=88; img.height=88; row.append(img); }
      const content = el('div','tc-line-body'), title = el('a','tc-product-title',item.product_title); title.href=item.url; content.append(title);
      if (item.variant_title && item.variant_title !== 'Default Title') content.append(el('p','tc-muted',item.variant_title));
      const prices = el('div','tc-prices');
      if (item.original_line_price > item.final_line_price) prices.append(el('s','tc-muted',money(item.original_line_price)));
      prices.append(el('strong','',money(item.final_line_price))); content.append(prices);
      for (const discount of item.line_level_discount_allocations || []) content.append(el('p','tc-discount',discount.discount_application.title));
      const controls = el('div','tc-controls'), stepper = el('div','tc-stepper');
      const minus=button('−','decrease',s.decrease+' '+item.product_title), plus=button('+','increase',s.increase+' '+item.product_title);
      stepper.append(minus,el('span','',String(item.quantity)),plus);
      controls.append(stepper,button(s.remove,'remove',s.remove+' '+item.product_title)); content.append(controls); row.append(content); items.append(row);
    }
    const upsells = surface.querySelector('[data-cart-upsells]'); upsells.replaceChildren();
    const offers = (config.upsells || []).filter(p=>p.available && !cart.items.some(i=>i.product_id===p.productId)).slice(0,4);
    if (cart.items.length && !offers.length && config.secondPan) {
      const pan = cart.items.find(i=>i.handle==='plateful-titanium-pro-pan' && i.quantity===1);
      if (pan) offers.push({id:pan.variant_id,title:s.secondPanTitle,price:pan.price,image:pan.image,available:true,second:true});
    }
    if (cart.items.length && offers.length) {
      upsells.append(el('h3','tc-upsell-heading',s.complete));
      for (const product of offers) {
        const offer = el('article','tc-upsell');
        if (product.image) {const img=el('img');img.src=product.image;img.alt=product.title;img.width=64;img.height=64;offer.append(img);}
        const body=el('div'),price=el('strong','',money(product.price));body.append(el('p','tc-product-title',product.title),price);
        if(product.second) body.append(el('p','tc-muted',s.secondPanHint));
        const add=button(s.add,'upsell',s.add+' '+product.title);add.dataset.variant=product.id;
        const variants=(product.variants||[]).filter(v=>v.available);
        if(variants.length>1){const select=el('select','tc-variant');select.setAttribute('aria-label',product.title);select.dataset.cartAction='variant';for(const variant of variants){const option=el('option','',variant.title);option.value=variant.id;option.selected=variant.id===product.id;select.append(option);}select.addEventListener('change',()=>{const variant=variants.find(v=>String(v.id)===select.value);add.dataset.variant=variant.id;price.textContent=money(variant.price);});body.append(select);}
        offer.append(body,add);upsells.append(offer);
      }
    }
    upsells.hidden = !upsells.childElementCount;
    surface.querySelector('[data-cart-total]').textContent = money(cart.total_price);
    const discounts=surface.querySelector('[data-cart-discounts]'); discounts.replaceChildren();
    for(const discount of cart.cart_level_discount_applications || []) discounts.append(el('p','tc-discount',discount.title+' −'+money(discount.total_allocated_amount)));
    const shipping=surface.querySelector('[data-cart-shipping]');
    const threshold=Number(config.freeShippingCents)||0;
    shipping.hidden=!threshold||!cart.items.length;
    if(threshold){ const remaining=Math.max(0,threshold-cart.total_price);shipping.querySelector('p').textContent=remaining?s.shippingRemaining.replace('{amount}',money(remaining)):s.shippingUnlocked;shipping.querySelector('progress').value=Math.min(100,cart.total_price/threshold*100); }
    surface.querySelector('[data-cart-status]').textContent=s.updated;
  }
  function renderAll() { surfaces.forEach(render);document.querySelectorAll('.cart_count,.cart-count').forEach(n=>{n.textContent=String(cart.item_count);}); }
  async function refresh() { cart=await request(config.cartUrl);renderAll(); }
  function openCart() {
    if(modal.hidden){returnFocus=document.activeElement;previousOverflow=document.body.style.overflow;modal.hidden=false;document.body.style.overflow='hidden';modal.querySelector('[data-cart-close]').focus();}
  }
  function closeCart(){modal.hidden=true;document.body.style.overflow=previousOverflow || '';returnFocus?.focus();}
  modal.querySelector('[data-cart-close]').addEventListener('click',closeCart);
  modal.addEventListener('click',event=>{if(event.target===modal)closeCart();});
  document.addEventListener('keydown',event=>{
    if(modal.hidden)return;
    if(event.key==='Escape')closeCart();
    if(event.key==='Tab'){
      const controls=[...modal.querySelectorAll('a[href],button:not([disabled]),input')].filter(n=>n.checkVisibility());
      if(event.shiftKey&&document.activeElement===controls[0]){event.preventDefault();controls.at(-1)?.focus();}
      else if(!event.shiftKey&&document.activeElement===controls.at(-1)){event.preventDefault();controls[0]?.focus();}
    }
  });
  surfaces.forEach(surface=>surface.addEventListener('click',async event=>{
    const control=event.target.closest('[data-cart-action], [data-cart-checkout]'); if(!control||busy)return;
    if(control.hasAttribute('data-cart-checkout')){location.assign(root+'checkout');return;}
    const row=control.closest('[data-key]'),item=cart.items.find(i=>i.key===row?.dataset.key),action=control.dataset.cartAction;
    if(action==='variant')return;
    setBusy(true);error();
    try{
      if(action==='upsell')await request(config.addUrl,{items:[{id:Number(control.dataset.variant),quantity:1}]});
      else if(item)await request(root+'cart/change.js',{id:item.key,quantity:action==='remove'?0:item.quantity+(action==='increase'?1:-1)});
      await refresh();
      const candidates=[...surface.querySelectorAll('[data-key]')];
      const sameRow=candidates.find(n=>n.dataset.key===item?.key);
      (sameRow?.querySelector('[data-cart-action="'+action+'"]')||surface.querySelector('[data-cart-checkout]')||surface.querySelector('a'))?.focus();
    }catch(e){error(e.message);}finally{setBusy(false);}
  }));
  document.querySelectorAll('[data-titanium-form]').forEach(form=>form.addEventListener('submit',async event=>{
    event.preventDefault();if(busy)return;
    const submit=form.querySelector('[type="submit"]'),id=form.querySelector('[name="id"]')?.value;if(!/^\d+$/.test(id||'')||submit.disabled)return;
    const quantity=Math.max(1,Math.floor(Number(form.querySelector('[name="quantity"]')?.value||document.querySelector('.quantity_wpr [name="quantity"]')?.value)||1));
    setBusy(true);submit.disabled=true;form.querySelector('[data-product-error]')?.remove();
    try{await request(config.addUrl,{items:[{id:Number(id),quantity}]});await refresh();openCart();}
    catch(e){const message=el('p','',e.message);message.dataset.productError='';message.setAttribute('role','alert');form.append(message);}
    finally{setBusy(false);submit.disabled=false;}
  }));
  document.querySelectorAll('.cart_icon').forEach(link=>link.addEventListener('click',async event=>{
    event.preventDefault();if(busy)return;openCart();setBusy(true);error();
    try{await refresh();}catch(e){error(e.message);}finally{setBusy(false);}
  }));
  if(document.querySelector('[data-cart-page]')){setBusy(true);refresh().catch(e=>error(e.message)).finally(()=>setBusy(false));}
})();
